import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import * as actions from "../../store/actions";
import {connect} from "react-redux";
import {green} from "@material-ui/core/colors";
import {useHistory} from "react-router-dom";
import {inputChangedHandler, prepareFormData, validateForm} from "../../shared/utility";
import TextField from "@material-ui/core/TextField";
import {Box} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
        textAlign: 'right',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    title: {
        fontSize: '24px'
    }
}));

let formData = {
    controls: {
        password: {
            label: 'New Password',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                length: {minimum: 8, allowEmpty: false},
                //passwordStrength: {},
            },
            valid: false,
            touched: false,
            showPassword: false,
        },
        confirmPassword: {
            placeholder: 'Confirm Password',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                length: {minimum: 8, allowEmpty: false},
                equality: { attribute: "password", message: 'Passwords do not match' }
            },
            valid: false,
            touched: false,
            showPassword: false,
        }
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

const Settings = (props) => {

    const classes = useStyles();
    formData = prepareFormData(formData);
    const [formState, setFormState] = useState(formData);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            //const confirmPassword = formState.controls.confirmPassword.value;
            const password = formState.controls.password.value;
            setLoading(true);
            props.onChangePassword(props.user, password, (err, res) => {
                setLoading(false);
                if (err) {
                    return ;
                }
                history.push('/dashboard');
            })
        }
    }

    const confirmPasswordField = formState.controls.confirmPassword;
    const passwordField = formState.controls.password;


    return (
        <React.Fragment>
            <h1 className={classes.title}>Settings</h1>
            <Box style={{color: '#00AEEF'}}>Change Password</Box>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div>
                    <TextField
                            name={passwordField.key}
                            value={passwordField.value}
                            type={passwordField.showPassword ? 'input' : 'password'}
                            label={passwordField.label}
                            placeholder={passwordField.label}
                            fullWidth
                            margin="normal"
                            onChange={event => inputChangedHandler(formState, setFormState, event.target.value, passwordField.key)}
                            helperText={passwordField.helperText}
                            error={!passwordField.valid && passwordField.touched}
                        />

                    
                </div>
                <div>
                    <TextField
                        name={confirmPasswordField.key}
                        value={confirmPasswordField.value}
                        type={confirmPasswordField.showPassword ? 'input' : 'password'}
                        label={confirmPasswordField.placeholder}
                        placeholder={confirmPasswordField.placeholder}
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, confirmPasswordField.key)}
                        helperText={confirmPasswordField.helperText}
                        error={!confirmPasswordField.valid && confirmPasswordField.touched}
                    />


                </div>

                {props.error &&
                <div className={`$classes.wrapper `}>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }

                <div className={classes.wrapper}>
                    <Button className={classes.button} type={"button"} variant={"outlined"} onClick={() => {
                        history.push('/dashboard')
                    }}
                    > Cancel</Button>

                    <Button className={classes.button} type={"button"} variant={"contained"} color={"primary"}
                            disabled={loading}
                            onClick={submitHandler}
                    > {loading &&
                    <CircularProgress size={30} className={classes.buttonProgress} color="secondary"/>} Save</Button>

                </div>
            </form>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        error: state.auth.error,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangePassword: (user, password, cb) => dispatch(actions.changePassword(user, password, cb)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);